import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import EntityDefinitionsContext from '../../../contexts/EntityDefinitionsContext';

const useSelectedEntity = () => {
  const { getEntityAndAppForSlug } = useContext(EntityDefinitionsContext);
  const { entityAppSlug } = useParams<{
    entityAppSlug: string;
  }>();

  const selectedEntity = useMemo(() => {
    if (!entityAppSlug) {
      return undefined;
    }

    return getEntityAndAppForSlug({ slug: entityAppSlug });
  }, [entityAppSlug, getEntityAndAppForSlug]);

  return selectedEntity;
};

export default useSelectedEntity;
